import { State, City } from 'country-state-city';

export const dateFormatter = (dateValue = new Date()) => {
  const date = new Date(dateValue);
  const minutes = date.getMinutes();

  return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()} ${date.getHours()}:${minutes < 10 ? '0' + minutes : minutes}`;
};

export const isToday = (date) => {
  const today = new Date();
  const todayYear = today.getFullYear();
  const todayMonth = today.getMonth();
  const todayDate = today.getDate();
  const inputYear = date.getFullYear();
  const inputMonth = date.getMonth();
  const inputDate = date.getDate();
  return todayYear === inputYear && todayMonth === inputMonth && todayDate === inputDate;
};

export const getCurrentDateTime = (type = '', date = null) => {
  let currentDate = new Date();
  if (date) {
    currentDate = new Date(date);
  }
  const minutes = currentDate.getMinutes();
  const month = currentDate.getMonth() + 1;
  const day = currentDate.getDate();
  return type === 'date'
    ? `${day < 10 ? '0' + day : day}-${month < 10 ? '0' + month : month}-${currentDate.getFullYear()}`
    : type === 'time'
      ? `${currentDate.getHours()}:${minutes < 10 ? '0' + minutes : minutes}`
      : dateFormatter(currentDate);
};

export const getCompareDate = () => {
  const currentDate = new Date();
  return currentDate.toISOString().split('T')[0];
};

export const getDateDifference = (pastDate = new Date(), nextDate = new Date()) => {
  const differenceMs = Math.abs(nextDate - pastDate);
  const differenceDays = Math.floor(differenceMs / (1000 * 60 * 60 * 24));
  const differenceMonths = Math.floor(differenceDays / 30);
  const differenceYears = Math.floor(differenceMonths / 12);
  const remainingDays = differenceDays % 30;
  const remainingMonths = differenceMonths % 12;
  return { year: differenceYears, month: remainingMonths, day: remainingDays };
};

export const getStatesByCountry = (countryCode) => {
  if (!countryCode) return [];
  return State.getStatesOfCountry(countryCode).map((state) => ({ name: state.name, _id: state.isoCode }));
};

export const getStateNameByStateCode = (countryCode, stateCode) => {
  return stateCode ? State.getStateByCodeAndCountry(stateCode, countryCode)?.name : '';
};

export const getCityByState = (countryCode, stateCode) => {
  if (!countryCode || !stateCode) return [];
  return City.getCitiesOfState(countryCode, stateCode).map((city) => ({
    name: city.name,
    _id: city.name.toLowerCase()
  }));
};

export const isObject = (value) => {
  const type = typeof value;
  return value != null && (type === 'object' || type === 'function');
};
export const getReccurssiveObjectKeys = (object, path) => {
  if (!isObject(object)) {
    return object;
  }
  path = path.split('.');
  const { length } = path;
  const arrayTypeMatch = path[length - 1].match(/([^\[]+)\[(\d+)\]/);
  let arrayIndex = undefined;
  if (arrayTypeMatch) {
    path[length - 1] = arrayTypeMatch[1];
    arrayIndex = parseInt(arrayTypeMatch[2]);
  }
  let index = -1;
  let nested = object;
  while (!!nested && ++index < length) {
    const key = path[index];
    nested = nested[key];
  }
  return arrayIndex ? nested?.[arrayIndex] : nested;
};

export const getKeyPathValue = (obj, parentKey = '', excludeKeys = []) => {
  let result = [];
  for (const key in obj) {
    if (excludeKeys.includes(key)) continue;
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      const currentKey = parentKey ? `${parentKey}.${key}` : key;

      if (typeof value === 'object' && value !== null) {
        result = result.concat(getKeyPathValue(value, currentKey));
      } else {
        result.push({ key: currentKey, value });
      }
    }
  }
  return result;
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();
  const dayDifference = today.getDate() - birthDate.getDate();
  if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
    age--;
  }
  return age;
};

export const getMonthYear = (dateString) => {
  const date = new Date(dateString);
  const options = { year: 'numeric', month: '2-digit' };
  return date.toLocaleDateString('en-GB', options);
};


export const formatRegTime = (time) => {
  const [hours, minutes] = time.split(':');
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);
  // Format to 12-hour time
  const options = { hour: '2-digit', minute: '2-digit', hour12: true };
  return date.toLocaleTimeString('en-US', options);
};


export const getISTDate = () => {
  const now = new Date();
  const IST_OFFSET = 5.5 * 60 * 60 * 1000; 
  const istDate = new Date(now.getTime() + IST_OFFSET);
  return istDate.toISOString().split('T')[0]; 
};
